import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { IntroAnimation } from "./components/IntroAnimation/IntroAnimation";

function MainContent() {
  return (
    <div className="overflow-hidden">
      <Outlet />
    </div>
  );
}

function App() {
  const [showContent, setShowContent] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Aviso de segurança no console
    console.clear();
    console.log(
      "%cBem-vindo à Loja Dominus!",
      "color: green; font-size: 30px; font-weight: bold; text-shadow: 2px 2px black;"
    );
    console.log(
      "%cATENÇÃO!",
      "color: red; font-size: 40px; font-weight: bold; text-shadow: 2px 2px black;"
    );
    console.log(
      "%cSe alguém te pediu para colar algo aqui, pode ser um golpe.",
      "color: orange; font-size: 20px;"
    );
    console.log(
      "%cNUNCA cole códigos que você não entende. Eles podem roubar seus dados.",
      "color: orange; font-size: 16px;"
    );
    console.log(
      "%cNossa equipe NUNCA irá pedir que você cole algo aqui.",
      "color: white; background-color: red; font-size: 16px; padding: 4px;"
    );

    const isHomePage = location.pathname === "/";

    if (!isHomePage) {
      setShowContent(true);
      return;
    }

    const timer = setTimeout(() => {
      setShowContent(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white">
      {!showContent ? (
        <IntroAnimation onComplete={() => setShowContent(true)} />
      ) : (
        <MainContent />
      )}
    </div>
  );
}

export default App;
